module.exports = __webpack_public_path__ + "static/media/shifan.e422aa5a.png";